import { render, staticRenderFns } from "./TagShow.vue?vue&type=template&id=3a8d9d9f&scoped=true"
import script from "./TagShow.vue?vue&type=script&lang=js"
export * from "./TagShow.vue?vue&type=script&lang=js"
import style0 from "./TagShow.vue?vue&type=style&index=0&id=3a8d9d9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d9d9f",
  null
  
)

export default component.exports